export default{
    section:'بخش',
    cardiacActivitiesTitle: 'عنوان',
    sectionStatus: 'وضعیت',
    cardiacActivities:'cardiac Activities',
    editCardiacActivities:'ویرایش cardiac Activities',
    addCardiacActivities:'cardiac Activities جدید',
}